import { useUserEventLogger } from '@repo/tracking-service';
import { SubTitle, Svg, List } from '@repo/ui';
import { useRouter } from 'next/router';

import s from './menu.module.scss';

import { MY_PAGE_PATHS } from '@/lib/constants/paths';

export const RefundSection = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const goRefundHistoryPage = () => {
    router.push(MY_PAGE_PATHS.환급받은내역);

    sendClickEvent('more_body_history');
  };

  return (
    <li>
      <SubTitle title={'나의 환급'} size={'medium'} className={s.menu_list_padding} />

      <ul>
        <li className={s.menu_list_padding}>
          <List
            title={'환급받은 내역보기'}
            leadingElement={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/fill-moneybag-gn-rg.svg`} alt="돈주머니" width={32} height={32} />}
            supportingElement={<Svg src={'ic_chevron-right.svg'} width={20} height={20} color={'#8A96A3'} />}
            primaryAction={true}
            onClick={goRefundHistoryPage}
          />
        </li>
      </ul>
    </li>
  );
};
